import { FC } from 'react';
import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './single-skeleton';
import { CmsComponentProps } from '@/types/cms';
const DynamicSingleProduct = dynamic(() => import('./single-product'), {
  ssr: false,
  loading: Skeleton
});

const SingleProduct: FC<CmsComponentProps> = ({ ...props }) => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });
  const skeleton = <Skeleton />;
  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }
  return <DynamicSingleProduct skeleton={skeleton} {...props} />;
};

export default SingleProduct;
